module.exports = "<p>\n  dashboard works!\n</p>\n"